/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerConfigPlayslipsCopy } from './CustomerConfigPlayslipsCopy';
import {
    CustomerConfigPlayslipsCopyFromJSON,
    CustomerConfigPlayslipsCopyFromJSONTyped,
    CustomerConfigPlayslipsCopyToJSON,
} from './CustomerConfigPlayslipsCopy';

/**
 * Playslip ordering feature settings: theming plus app-level UI copy.
 * Per-game copy lives in the GDS game display schema, not here.
 * @export
 * @interface CustomerConfigPlayslips
 */
export interface CustomerConfigPlayslips {
    /**
     * 
     * @type {CustomerConfigPlayslipsCopy}
     * @memberof CustomerConfigPlayslips
     */
    copy?: CustomerConfigPlayslipsCopy;
    /**
     * Primary font color in #RRGGBB hex format.
     * @type {string}
     * @memberof CustomerConfigPlayslips
     */
    fontColorPrimary?: string;
    /**
     * Primary brand color in #RRGGBB hex format.
     * @type {string}
     * @memberof CustomerConfigPlayslips
     */
    brandColorPrimary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerConfigPlayslips
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the CustomerConfigPlayslips interface.
 */
export function instanceOfCustomerConfigPlayslips(value: object): value is CustomerConfigPlayslips {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function CustomerConfigPlayslipsFromJSON(json: any): CustomerConfigPlayslips {
    return CustomerConfigPlayslipsFromJSONTyped(json, false);
}

export function CustomerConfigPlayslipsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerConfigPlayslips {
    if (json == null) {
        return json;
    }
    return {
        
        'copy': json['copy'] == null ? undefined : CustomerConfigPlayslipsCopyFromJSON(json['copy']),
        'fontColorPrimary': json['fontColorPrimary'] == null ? undefined : json['fontColorPrimary'],
        'brandColorPrimary': json['brandColorPrimary'] == null ? undefined : json['brandColorPrimary'],
        'enabled': json['enabled'],
    };
}

export function CustomerConfigPlayslipsToJSON(value?: CustomerConfigPlayslips | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'copy': CustomerConfigPlayslipsCopyToJSON(value['copy']),
        'fontColorPrimary': value['fontColorPrimary'],
        'brandColorPrimary': value['brandColorPrimary'],
        'enabled': value['enabled'],
    };
}

